var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Hiding the default header"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeHeader) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-card-text', [_c('span', [_vm._v("You can disable the default header (including the close button) via the ")]), _c('code', [_vm._v("no-header")]), _c('span', [_vm._v(" prop. Note that you will need to provide a method of closing the sidebar. The ")]), _c('code', [_vm._v("default")]), _c('span', [_vm._v(" slot is scoped, which includes a")]), _c('code', [_vm._v("hide()")]), _c('span', [_vm._v(" method that can be used to close the sidebar.")])]), _c('div', [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }, {
      name: "b-toggle",
      rawName: "v-b-toggle.sidebar-no-header",
      modifiers: {
        "sidebar-no-header": true
      }
    }],
    attrs: {
      "variant": "outline-primary"
    }
  }, [_vm._v(" Toggle Sidebar ")]), _c('b-sidebar', {
    attrs: {
      "id": "sidebar-no-header",
      "aria-labelledby": "sidebar-no-header-title",
      "no-header": "",
      "bg-variant": "white",
      "shadow": "",
      "backdrop": ""
    }
  }, [_c('sidebar-content', {
    staticClass: "pt-2"
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }